import Img1 from "./GalleryImages/1.webp";
import Img2 from "./GalleryImages/2.webp";
import Img3 from "./GalleryImages/3.webp";
import Img4 from "./GalleryImages/4.webp";
import Img5 from "./GalleryImages/5.webp";
import Img6 from "./GalleryImages/6.webp";
import Img7 from "./GalleryImages/7.webp";
import Img8 from "./GalleryImages/8.webp";
import Img9 from "./GalleryImages/9.webp";
import Img10 from "./GalleryImages/10.webp";
import Img11 from "./GalleryImages/11.webp";
import Img12 from "./GalleryImages/12.webp";
import Img13 from "./GalleryImages/13.webp";
import Img14 from "./GalleryImages/14.webp";
import Img15 from "./GalleryImages/15.webp";
import Img16 from "./GalleryImages/16.webp";
import Img17 from "./GalleryImages/17.webp";
import Img18 from "./GalleryImages/18.webp";
import Img19 from "./GalleryImages/19.webp";
import Img20 from "./GalleryImages/20.webp";

export const galleryImages = [
    { src: Img1, type: "large" },
    { src: Img2, type: "portrait" },
    { src: Img3, type: "square" },
    { src: Img4, type: "landscape" },

    { src: Img5, type: "portrait" },
    { src: Img6, type: "square" },
    { src: Img7, type: "large" },
    { src: Img8, type: "square" },

    { src: Img9, type: "landscape" },
    { src: Img10, type: "portrait" },
    { src: Img11, type: "square" },
    { src: Img12, type: "portrait" },

    { src: Img13, type: "large" },
    { src: Img14, type: "square" },
    { src: Img15, type: "landscape" },
    { src: Img16, type: "portrait" },

    { src: Img17, type: "square" },
    { src: Img18, type: "portrait" },
    { src: Img19, type: "landscape" },
    { src: Img20, type: "square" }
];